/**
*  Content Accordion With Icons JS
* -----------------------------------------------------------------------------
*
* All the JS for the  Content Accordion With Icons component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-accordion-with-icons',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-accordion-with-icons__title' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
      } );

      $( '.content-accordion-with-icons__content' ).each( function( index ) {
        if ( index === 1 ) {
          $( this ).addClass( 'xl:ml-auto' );
        }
      } );

      let maxHeight = -1;

      $( '.content-accordion-with-icons__header' ).each( function() {
        maxHeight = maxHeight > $( this ).height() ? maxHeight : $( this ).height();
      } );

      $( '.content-accordion-with-icons__header' ).each( function() {
        $( this ).height( maxHeight );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-accordion-with-icons', COMPONENT );
} )( app );
